import React, {useEffect} from 'react'
import {
    getActivityCount,
    getHighlightCount,
} from '../../selectors/ninchat'
import {useAppSelector} from 'hooks'

const favicon = document.getElementById('favicon') as HTMLLinkElement
const [title] = document.getElementsByTagName('title') as HTMLCollectionOf<HTMLTitleElement>
const defaultFavicon = favicon.href
const defaultTitle = title.text

const updateFavicon = (activityCount: number, highlightCount: number): void => {
    if (activityCount > 0) {
        const activityStyle = `
            .st0{fill:#000000;}
            .stext0{fill:#FFFFFF; font: bold 18px sans-serif;}
            @media (prefers-color-scheme: dark) {
                .st0{fill:#FFFFFF;}
                .stext0{fill:#000000; font: bold 18px sans-serif;}
            }
        `

        const highlightStyle = `
            .st0{fill:#008AFF;}
            .stext0{fill:#FFFFFF; font: bold 18px sans-serif;}
        `

        // Add count to highlight SVG
        const svg = `
            <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 32 32"
                style="enable-background:new 0 0 32 32;"
                xml:space="preserve"
            >
                <style type="text/css">
                    ${highlightCount > 0 ? highlightStyle : activityStyle}
                </style>
                <path class="st0" d="M16.3,0c12.2,6.8,11.2,15.5,11.2,15.5l4.5,0.8c-6.8,12.1-15.5,11.3-15.5,11.3L15.7,32
                    C3.6,25.3,4.4,16.5,4.4,16.5L0,15.6C6.9,3.4,15.5,4.4,15.5,4.4L16.3,0z"/>
                <text class="stext0" x="50%" y="50%" dominant-baseline="middle" text-anchor="middle">${activityCount < 100 ? activityCount.toString() : '!'}</text>
            </svg>`

        favicon.href = `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`
        title.text = `${defaultTitle} (${activityCount})`
    } else {
        favicon.href = defaultFavicon
        title.text = defaultTitle
    }
}

const DynamicFavicon: React.FC = (): React.ReactElement => {
    const activityCount = useAppSelector(({
        ninchat, ui,
    }) => getActivityCount(ninchat, ui.queue_pickup_delays))
    const highlightCount = useAppSelector(({
        ninchat, ui,
    }) => getHighlightCount(ninchat, ui.queue_pickup_delays))

    useEffect(() => {
        updateFavicon(activityCount, highlightCount)
    }, [activityCount, highlightCount])

    return (
        <div style={{visibility: 'hidden'}} />
    )
}

export default DynamicFavicon
